import PatternsList from "./PatternsList"

export default PatternsList